module.exports = __webpack_public_path__ + "static/img/samajuri (35).6530445.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (35).jpg
// module id = DC8U
// module chunks = 0